import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { GuardService } from '../../../service/guard.service';
import { ResultpagesharedService } from '../../../service/resultpageshared.service';
declare const window: any;

@Component({
  selector: 'app-track-conversion-funnel',
  templateUrl: './track-conversion-funnel.component.html',
  styleUrls: ['./track-conversion-funnel.component.scss'],
})
export class TrackConversionFunnelComponent implements OnInit, OnDestroy {
  private token!: string;
  private subscription?: Subscription;

  constructor(
    private guardService: GuardService,
    private resultpagesharedService: ResultpagesharedService,
  ) {}

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('t') ?? '';
    const isCreditcenter = !!this.guardService.checkKreditcenter();

    const C24App = window['C24App' as any];
    if (!C24App || isCreditcenter || this.token === '') {
      return;
    }

    this.subscription = this.resultpagesharedService
      .onAllocationGroupReady()
      .pipe(take(1))
      .subscribe(() => {
        const success = this.resultpagesharedService.matchesGoodCustomerAllocationGroup()
          ? 'Yes'
          : 'No';

        C24App.trackConversionFunnel(
          {
            productSSO: 'credit',
            voucherCode: '',
            data: {
              token: this.token,
              success,
            },
          },
          () => {},
        );
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
